export default "__VITE_ASSET__Cdohq25d__"